import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12487496&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12487496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12487496')) {
      api.createRecord('12487496', component.options)
    } else {
      api.reload('12487496', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12487496&scoped=true&", function () {
      api.rerender('12487496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/rule/index.vue"
export default component.exports